export default __webpack_public_path__ + "static/media/icon_box-widgets-close.c61b79d4.svg";